import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { iamService } from '@/api/services/iam';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/permissions',
)({
  beforeLoad: ({ params: { accountId } }) => ({
    listPermissionsQuery: iamService.listPermissionsQuery({ accountId }),
  }),
  // The tab reads the permissions with a suspense hook, so they are warmed here instead of mid-render.
  // `prefetchQuery` and not `fetchQuery`: reading roles is the gate the parent already applied, and an
  // account that may not read permissions gets the tab with none rather than a refusal.
  loader: ({ context: { queryClient, listPermissionsQuery } }) => queryClient.prefetchQuery(listPermissionsQuery),
  component: lazyRouteComponent(
    () => import('@/components/AccessManagement/RolePermissions'),
    'RoleIdPermissionsComponent',
  ),
  pendingMs: 200,
  pendingComponent: lazyRouteComponent(
    () => import('@/components/AccessManagement/RolePermissionsSkeleton'),
    'RolePermissionsSkeleton',
  ),
});
